<template>
  <div class='opc-cart-item__text'>
    <div class='opc-cart-item__text-label'>
      {{ $t('billing.order_summary.subscription_ends_in_one_year') }}
    </div>
    <div class='opc-cart-item__text-tips'>
      {{ $t('billing.order_summary.next_auto_renewal', { date: nextAutoRenewalDate }) }}
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { BILLING_CYCLE } from '@/common/constants';
import { dateformat } from '@/utils/dateformat';

export default {
  name: 'NextAutoRenewal',
  props: {
    billingCycle: {
      type: String,
      default: BILLING_CYCLE.ANNUAL_TERM_MONTHLY,
    },
  },
  computed: {
    nextAutoRenewalDate() {
      return moment(Date.now())
        .add(1, 'year')
        .format(dateformat);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/scss-utils.scss';
.opc-cart-item__text {
  &-label {
    color: var(--Neutral-Midnight, #00053D);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    @include darkTextColor;
  }
  &-tips {
    color: var(--Neutral-Neutral08, #515079);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    @include darkTextColor;
  }
}
</style>
